import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CAppSubTitle from '../../../../app/components/CAppSubTitle';
import AppCustomIcon from '../../../../app/features/icon/AppIcon';
import useDocumentFiles from '../../../document/hooks/useDocumentFiles';
import IFund from '../../interfaces/fund/IFund';

import IFundFilters from '../../interfaces/fund/IFundFilters';
import investmentFundDocumentsLang from '../../langs/investmentFundDocumentsLang';
import investmentFundLang from '../../langs/investmentFundLang';
import useInvestExpertises from '../../hooks/expertise/useInvestExpertises';
import VDocumentFilesTable from '../../../document/views/VDocumentFilesTable';
import IDocumentFile from '../../../document/interfaces/IDocumentFile';
import useInvestFundDocuments from '../../hooks/fund/useInvestFundDocuments';

type VInvestFundDocumentsProps = {
	fund: IFund;
	filters: IFundFilters;
};

type IDocumentTableItem = {
	id: string;
	name: string;
	displayColumns: string[];
	documents: IDocumentFile[];
};

const VInvestFundDocuments = (props: VInvestFundDocumentsProps) => {
	const { fund } = props;

	const { t } = useTranslation();

	const { documents } = useDocumentFiles();
	const investExpertises = useInvestExpertises();
	const [documentsForFund, setDocumentsForFund] = useState<IDocumentFile[] | null>(null);

	useEffect(() => {
		if (fund && documents && investExpertises) {
			setDocumentsForFund(
				_.orderBy(
					documents.filter((x) => x.fund?.id === fund.id),
					['date'],
					['desc'],
				),
			);
		} else {
			setDocumentsForFund(null);
		}
	}, [fund, documents, investExpertises]);

	const investFundDocuments = useInvestFundDocuments();
	const [documentsBySection, setDocumentsBySection] = useState<IDocumentTableItem[] | null>(null);

	useEffect(() => {
		if (fund && investFundDocuments && documentsForFund) {
			const investFundDocument = investFundDocuments.find((x) => x.tag === fund.typeTag);
			setDocumentsBySection(
				investFundDocument?.documentTables.map((x) => ({
					id: x.id,
					name: x.name,
					displayColumns: x.displayColumns,
					documents: documentsForFund.filter(
						(doc) => x.filter.includes(doc.documentType) !== x.filterOpposite,
					),
				})) ?? null,
			);
		}
	}, [fund, investFundDocuments, documentsForFund]);

	return (
		<>
			<CAppSubTitle
				title={t(investmentFundLang.title_documents.tag)}
				subtitle={t(investmentFundDocumentsLang.x_files.tag, {
					count: documentsForFund ? documentsForFund.length : 0,
				})}
				icon={<AppCustomIcon tag="folders" className="icon" />}
			/>
			{documentsBySection?.map((doc) => (
				<div key={doc.id}>
					<Typography variant="h3" component="h3">
						{doc.name}
					</Typography>

					<Box sx={{ marginBottom: '40px' }} id={doc.id}>
						<VDocumentFilesTable documents={doc.documents} displayColumns={doc.displayColumns} />
					</Box>
				</div>
			))}
		</>
	);
};

export default VInvestFundDocuments;
